import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
export var groupOptions = function(param) {
    var data = param.data;
    var _sortedData;
    var sortedData = [];
    var unGroupedData = [];
    var groupedData = data.reduce(function(acc, item, index) {
        if (item.group) {
            if (acc[item.group]) {
                acc[item.group].push(index);
            } else {
                acc[item.group] = [
                    index
                ];
            }
        } else {
            unGroupedData.push(index);
        }
        return acc;
    }, {});
    Object.keys(groupedData).forEach(function(groupName) {
        var _sortedData;
        (_sortedData = sortedData).push.apply(_sortedData, _to_consumable_array(groupedData[groupName].map(function(index) {
            return data[index];
        })));
    });
    (_sortedData = sortedData).push.apply(_sortedData, _to_consumable_array(unGroupedData.map(function(itemIndex) {
        return data[itemIndex];
    })));
    return sortedData;
};

//# sourceMappingURL=group-options.js.map